import script from "./MCF_NT_001.vue?vue&type=script&setup=true&lang=js"
export * from "./MCF_NT_001.vue?vue&type=script&setup=true&lang=js"

import "./MCF_NT_001.vue?vue&type=style&index=0&id=1b2c5c86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b2c5c86"]])

export default __exports__